import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  exportAgentCustomer({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCustomer/exportAgentCustomer`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findCustomerList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCustomer/findCustomerList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportCustomerList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCustomer/exportCustomerList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findCustomerOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCustomer/findCustomerOrderList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCustomer/exportOrderList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
